import { Helmet } from 'react-helmet';
import { Box, Container, Card, CardContent, CardHeader, Button, Divider, Grid, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Typography } from '@mui/material';
import React, { Component } from "react";
import SearchRecords from 'src/components/pages/vaccination/dashboard/SearchRecords';
import StyledDropzone from '../components/pages/reports/StyledDropzone'
import { _axios } from 'src/plugins/axios';
import CsvDownloader from 'react-csv-downloader'
import masterStatus from 'src/models/status';
import commonService from 'src/service/common'
import moment from 'moment'
import * as _ from 'lodash';

const statusList = JSON.parse(JSON.stringify(masterStatus))

class Reports extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter: {
        dateRange: [],
        status: ''
      },
      exportConfig: {
        columns: [],
        datas: []
      },
      reports: [],
      uplaodStatus: false,
      showmsg: false
    }
  }

  handleDownload(id) {
    _axios.get(`masterData/getFile/${id}`)
      .then((response) => {
        if (response.status === 200) {
          if (response.data && response.data.preSignedUrl) {
            this.downloadFile(response.data.preSignedUrl)
          }
        }
        // console.log(response.data)
      })
      .catch((err) => {
        console.log(err)
      });
  }

  downloadFile(url) {
    var link = document.createElement("a");
    link.setAttribute('download', '');
    link.href = url;
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  uploadFile(files, type) {
    this.setState({
      uplaodStatus: false
    })
    const file = new FormData()
    file.append('attachment', files[0])
    file.append('filename', files[0].name)
    if(type) {
      file.append('type', type)
    }
    _axios.post('masterData/uploadFile', file,
      {
        headers: {
          authtoken: commonService.getAuthToken()
        }
      }
    ).then((res) => {
      // console.log(res)
      if (res.status === 200) {
        this.setState({
          uplaodStatus: true
        })
        this.fetchReports()
      }
    }).catch((err) => {
      console.log(err)
    })
  }

  fetchReports() {
    _axios.get('masterData/fetchUploadedFiles', {
      headers: {
        authtoken: commonService.getAuthToken()
      }
    }).then((res) => {
      // console.log(res)
      if (res.data && res.data.data) {
        this.setState({
          reports: _.reverse(res.data.data)
        })
      }
    }).catch((err) => {
      console.log(err)
    })
  }

  componentDidMount() {
    this.fetchReports()
    // this.downloadFile()
  }

  loadRecords() {
    let statusObj;
    if (this.state.filter.status) {
      statusObj = statusList.find(each => each.status == this.state.filter.status)
    }
    let payload = {
      startIndex: 0,
      pageSize: 5000,
      statusIds: statusObj ? statusObj.statusId : null
    }
    if(this.state.filter.dateRange.length) {
      let startDate = new Date(this.state.filter.dateRange[0])
      let endDate = new Date(this.state.filter.dateRange[1])
      payload["apptDateBegin"] = startDate.getFullYear() + "-" + (("0" + (startDate.getMonth() + 1)).slice(-2)) + "-" + ("0" + startDate.getDate()).slice(-2)
      payload["apptDateEnd"] = endDate.getFullYear() + "-" + (("0" + (endDate.getMonth() + 1)).slice(-2)) + "-" + ("0" + endDate.getDate()).slice(-2)    
    } else {
      payload = {
        apptDateBegin : this.state.filter.dateRange[0],
        apptDateEnd : this.state.filter.dateRange[1]
      }
    }
    this.setState({ showmsg: false })
    _axios.post('masterData/MasterData', payload, {
      headers: {
        authtoken: commonService.getAuthToken()
      }
    }
    )
      .then((response) => {
        if (response.data.masterData && response.data.masterData.length) {
          let exportOption = {
            columns: [],
            datas: []
          }
          response.data.masterData.forEach(item => {
            exportOption.datas.push(item)
          })
          Object.keys(response.data.masterData[0]).forEach((key) => {
            let header = key.replace(/([A-Z])/g, " $1")
            exportOption.columns.push({ id: key, displayName: header.charAt(0).toUpperCase() + header.slice(1) })
          })
          this.setState({
            exportConfig: exportOption
          })
        } else {
          this.setState({
            exportConfig: {
              columns: [],
              datas: []
            },
            showmsg: true
          })
        }
      }).catch((error) => {
        console.log(error);
      })
  }

  uploadAnother() {
    this.setState({ uplaodStatus: false })
  }

  render() {

    return (
      <>
        <Helmet>
          <title>Vaccination | Uploads</title>
        </Helmet>
        {/* <Grid
          item
          lg={12}
          md={6}
          xl={3}
          xs={12}
        >
          <Box
            sx={{
              backgroundColor: 'background.default',
              minHeight: '100%',
              py: 3
            }}
          >
            <Container maxWidth={false}>
              <Card>
                <CardHeader
                  title="Download Report"
                />
                <Divider />
                <CardContent className="display-center">
                  <Grid
                    container
                    spacing={3}
                  >
                    <Grid
                      item
                      lg={9}
                      sm={6}
                      xl={9}
                      xs={12}
                    >
                      <SearchRecords filter={this.state.filter} setFilters={(value) => this.setState({ filter: value })} onRefresh={() => this.loadRecords()} />
                    </Grid>
                    <Grid
                      item
                      lg={3}
                      sm={6}
                      xl={3}
                      xs={12}
                    >
                      {this.state.exportConfig.datas.length ? <CsvDownloader filename="reports"
                        extension=".csv"
                        columns={this.state.exportConfig.columns}
                        datas={this.state.exportConfig.datas}>
                        <Button fullWidth color="secondary" variant="contained" className="m-t-10">
                          Download
                        </Button>
                      </CsvDownloader> : (this.state.showmsg && <Typography variant="h5">No Records Found</Typography>)}
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Container>
          </Box>
        </Grid>
         */}
        <Grid
          item
          lg={12}
          md={12}
          xl={3}
          xs={12}
        >
          <Box
            sx={{
              backgroundColor: 'background.default',
              minHeight: '100%',
              py: 2
            }}
          >
            <Container maxWidth={false}>
              <Card 
                sx={{
                  borderRadius: 4,
                  boxShadow: '0 0 4px rgba(0,0,0,0.15)'
                }}>
                <CardHeader
                  action={(
                    <Button
                      // endIcon={<ArrowDropDownIcon />}
                      disabled
                      size="small"
                    >
                      Sample Template
                    </Button>
                  )}
                  title="Upload Excel"
                />
                <Divider sx={{mx:2}}/>
                <CardContent className="display-center">
                  {this.state.uplaodStatus ?
                    <Box
                      sx={{
                        width: 600,
                        height: 240,
                        position: 'relative'
                      }}>
                      <div style={{
                        textAlign: 'center',
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)'
                      }}>
                        <img
                          alt="Uploaded Successful"
                          src="/static/images/checked.svg"
                          style={{
                            display: 'inline-block',
                            height: 60
                          }}
                        />
                        <Typography variant="h4" sx={{ mt: 3 }}>File Uploaded Successfully</Typography>
                        <Button variant="contained" onClick={() => this.uploadAnother()} sx={{ mt: 3, boxShadow: '0 0 4px rgba(0,0,0,0.15)' }}>
                          Upload Another
                        </Button>
                      </div>
                    </Box>
                    :
                    <Box
                      sx={{
                        width: 600,
                        height: 240,
                        bgcolor: '#cbe2ff',
                        borderRadius: '20pt'
                      }}
                    >
                      <StyledDropzone uplaodStatus={this.state.uplaodStatus} submitFile={(file, type) => this.uploadFile(file, type)} />
                    </Box>
                  }
                </CardContent>
              </Card>
            </Container>
          </Box>
        </Grid>
        <Grid
          item
          lg={12}
          md={12}
          xl={3}
          xs={12}
        >
          <Box
            sx={{
              backgroundColor: 'background.default',
              minHeight: '100%',
            }}
          >
            <Container maxWidth={false}>
              <Card 
                sx={{
                  mb: 2,
                  borderRadius: 4,
                  boxShadow: '0 0 4px rgba(0,0,0,0.15)'
                }}>
                <CardHeader
                  // action={(
                  // <Button
                  //   // endIcon={<ArrowDropDownIcon />}
                  //   size="small"
                  // >
                  //   Sample Template
                  // </Button>
                  // )}
                  title="Uploads"
                />
                <Divider sx={{mx: 2}}/>
                <CardContent>
                  <Box sx={{ maxWidth: 600, minWidth: 150 }}>
                    <TableContainer sx={{ minHeight: '100%' }}>
                      <Table stickyHeader aria-label="Reports">
                        <TableHead>
                          <TableRow>
                            <TableCell>
                              Report
                            </TableCell>
                            <TableCell>
                              Uploaded At
                            </TableCell>
                            <TableCell>
                              Type
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {this.state.reports.length ? this.state.reports.map((report) => (
                            <TableRow
                              hover
                              key={report.id}
                            >
                              <TableCell>
                                <a style={{color: '#1778f2', cursor: 'pointer'}} onClick={() => this.handleDownload(report.s3_key)} target='_blank'>
                                  {report.filename}
                                </a>
                              </TableCell>
                              <TableCell>
                                {moment(report.createdAt).format('DD/MM/YYYY h:mm a')}
                              </TableCell>
                              <TableCell>
                                {report.type}
                              </TableCell>
                            </TableRow>
                          )) : <Typography mt={3} variant="h6"> No reports found </Typography> }
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Box>
                </CardContent>
              </Card>
            </Container>
          </Box>
        </Grid>

      </>
    )
  }
}

export default Reports;
